import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import * as api from './apihandler';
import { AddContactAddress, AddCustomer, AddDeliveryAddress, CustomerById, CustomerList, EditContactAddress, EditCustomer, EditDeliveryAddress } from "../models/customer.models";

export class CustomerApi {
    bearer = localStorage.getItem('bearer') as string;
    constructor(private http: HttpClient) { }

    getCustomersPagination(start: number, stop: number): Observable<CustomerList[]> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<CustomerList[]>(api.jubloApi + `api/Website/Customer/GetCustomersPagination/${start.toString()}/${stop.toString()}`, { headers })
    }

    // searchCustomer(searchString: string, amount: number): Observable<CustomerList[]> {
    //     const headers = new HttpHeaders({ 'Authorization': this.bearer });
    //     return this.http.get<CustomerList[]>(api.jubloApi + `api/Website/Customer/GetCustomersSearch/${searchString}/${amount}`, { headers })
    // }

    searchCustomer(searchString: string, amount: number): Observable<CustomerList[]> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<CustomerList[]>(api.jubloApi + 'api/Website/Customer/GetCustomersSearch', { search: searchString, amount: amount}, { headers });
    }

    getCustomerById(customerId: string): Observable<CustomerById> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<CustomerById>(api.jubloApi + `api/Website/Customer/GetCustomerPlainById/${customerId}`, { headers })
    }

    getCustomerDataById(customerId: string): Observable<CustomerById> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get<CustomerById>(api.jubloApi + `api/Website/Customer/GetCustomerById/${customerId}`, { headers })
    }

    editCustomer(customerId: string, customer: EditCustomer): Observable<void> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.put<void>(api.jubloApi + `api/Website/Customer/EditCustomer/${customerId}`, customer, { headers })
    }

    addCustomer(customer: AddCustomer): Observable<string> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<string>(api.jubloApi + 'api/Website/Customer/AddCustomer', customer, { headers })
    }

    addDeliveryAddress(delivery: AddDeliveryAddress): Observable<string> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<string>(api.jubloApi + 'api/Website/Customer/AddDeliveryAddress', delivery, { headers })
    }

    editDeliveryAddress(deliveryId: string, delivery: EditDeliveryAddress): Observable<void> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.put<void>(api.jubloApi + `api/Website/Customer/EditDelivery/${deliveryId}`, delivery, { headers })
    }

    addContactAddress(contact: AddContactAddress): Observable<string> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.post<string>(api.jubloApi + 'api/Website/Customer/AddContactAddress', contact, { headers })
    }

    editContactAddress(contactId: string, contact: EditContactAddress): Observable<void> {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.put<void>(api.jubloApi + `api/Website/Customer/EditContact/${contactId}`, contact, { headers })
    }

    getCustomerCases(customerId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Website/Customer/GetCustomerCases/${customerId}`, { headers })
    }

    getCustomerOffers(customerId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Website/Customer/GetCustomerOffers/${customerId}`, { headers })
    }

    getCustomerTags() {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + 'api/IntegrationSync/GetCustomerTags', { headers })
    }

    addTagToCustomer(customerId: string, tagId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.patch(api.jubloApi + `api/IntegrationSync/AddTagToCustomer/${customerId}/${tagId}`, tagId, { headers })
    }

    removeTagFromCustomer(customerId: string, tagId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.delete(api.jubloApi + `api/IntegrationSync/RemoveTagFromCustomer/${customerId}/${tagId}`, { headers })
    }

    getCustomerProperties(customerId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Website/Customer/GetCustomerProperties/${customerId}`, { headers })
    }

    getCustomerDeliveryPagination(customerId: string, start: number, end: number) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Website/Customer/GetDeliveryAddressesPagination/${customerId}/${start}/${end}`, { headers })
    }

    getCustomerContacts(customerId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Website/Customer/GetContactAddresses/${customerId}`, { headers })
    }

    getAssets(customerId: string) {
        const headers = new HttpHeaders({ 'Authorization': this.bearer });
        return this.http.get(api.jubloApi + `api/Assets/GetAssetsByCustomerId/${customerId}`, { headers })
    }
}